export const linkTypes = ['playerLink', 'recipientPlayerLink', 'teamLink', 'currentTeam'] as const;

export type LinkType = (typeof linkTypes)[number];
